import styled from 'styled-components'
import { WHITE } from '../../utils/colors'

export const Container = styled.div`
  width: 148px;
  height: 148px;
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  text-align: center;

  .button {
    width: 100%;
    height: 100%;
    border: none;
    background-color: rgba(0,0,0,0.4);
    color: ${WHITE};
    line-height: 190px;
    cursor: pointer;
    background-position: center;
    background-size: cover;
  }

  input {
    opacity: 0;
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
